/* Roy UX pass — Forever - Do Not Touch 1 only. */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SALE = '/collections/all-sale-styles-women-men';
  const q = (params) => `${SALE}?${new URLSearchParams(params).toString()}`;
  const salePrice = (amount) => q({'filter.v.availability':'1','filter.v.price.lte':String(amount)});
  const saleSize = (value) => q({'filter.v.availability':'1','filter.v.option.size':value});

  function addPrimaryNavLinks(){
    const desktop = document.querySelector('.header__inline-menu .list-menu--inline');
    if (desktop) {
      const labels = [...desktop.querySelectorAll(':scope > li > a')].map(a => a.textContent.trim().toLowerCase());
      const make = (label, href, cls='') => {
        const li = document.createElement('li');
        li.className = `list-menu-item roy-nav-item ${cls}`.trim();
        li.innerHTML = `<a href="${href}" class="header__menu-item list-menu__item link focus-inset"><span class="list-menu-line link--text" title="${label}">${label}</span></a>`;
        return li;
      };
      const saleItem = [...desktop.children].find(li => /sale|last call/i.test(li.textContent));
      if (!labels.includes('our stores')) desktop.insertBefore(make('Our Stores','/pages/store-locator'), saleItem || null);
    }

    document.querySelectorAll('.burger-menu__top > .burger-menu__list').forEach(list => {
      const text = [...list.querySelectorAll(':scope > li')].map(li => li.textContent.trim().toLowerCase());
      const make = (label, href) => {
        const li = document.createElement('li');
        li.className = 'burger-menu__list-first roy-nav-item';
        li.innerHTML = `<a href="${href}" class="burger-menu__item burger-menu__item-first burger-menu__item-first-level burger-menu__link h3"><span>${label}</span></a>`;
        return li;
      };
      const saleItem = [...list.children].find(li => /sale|last call/i.test(li.textContent));
      if (!text.some(t => t === 'our stores')) list.insertBefore(make('Our Stores','/pages/store-locator'), saleItem || null);
    });
  }

  function getSaleConfig(menu){
    const node=menu?.querySelector('.roy-last-call-config');
    if(!node) return {};
    try{return JSON.parse(node.textContent||'{}');}catch(e){return {};}
  }
  const validLinks = items => (Array.isArray(items)?items:[]).filter(i=>i&&i.label&&i.url);
  const listMarkup = items => validLinks(items).map(i=>`<li><a class="roy-sale-link" href="${i.url}">${i.label}</a></li>`).join('');
  function saleDesktopMarkup(config={}){
    const sizeLinks = [
      ['4–5.5','4,4.5,5,5.5'],['6','6'],['6.5','6.5'],['7','7'],['7.5','7.5'],['8','8'],['8.5','8.5'],['9','9'],['9.5','9.5'],['10','10'],['10.5','10.5'],['11–12','11,11.5,12']
    ].map(([label,value]) => `<a class="roy-sale-size" href="${saleSize(value)}">${label}</a>`).join('');
    const categories=validLinks(config.categories).length?config.categories:[
      {label:'All sale styles',url:SALE},{label:"Women's sale",url:'/collections/sale-shoes-for-women'},{label:'Sale shoes',url:'/collections/sale-shoes'},{label:'Accessories on sale',url:'/collections/accessories-sale'},{label:"Kids' sale",url:'/collections/kids-sale'}
    ];
    const styles=validLinks(config.styles).length?config.styles:[
      {label:'Sale boots',url:'/collections/women-sale-boots'},{label:'Sale sandals',url:'/collections/women-sale-sandals'},
      {label:'Sale sneakers',url:q({'filter.v.availability':'1','filter.p.product_type':'Sneakers'})},
      {label:'Sale heels',url:q({'filter.v.availability':'1','filter.p.product_type':'Heels'})},
      {label:'Sale flats & loafers',url:q({'filter.v.availability':'1','filter.p.product_type':'Flats'})},
      {label:'Sale wedges',url:q({'filter.v.availability':'1','filter.p.product_type':'Wedges'})},
      {label:'Sale mules',url:q({'filter.v.availability':'1','filter.p.product_type':'Mules'})}
    ];
    const priceLabels=(config.priceLabels||[]).length?config.priceLabels:['Sale under $50','Sale under $100','Sale under $150','Sale under $200'];
    return `<div class="sss-mega-menu__shell roy-sale-shell">
      <section class="roy-sale-col"><span class="roy-sale-heading">${config.catHeading||'Shop by category'}</span><ul class="roy-sale-list">${listMarkup(categories)}</ul></section>
      <section class="roy-sale-col"><span class="roy-sale-heading">${config.styleHeading||'Shop by style'}</span><ul class="roy-sale-list">${listMarkup(styles)}</ul></section>
      <section class="roy-sale-col"><span class="roy-sale-heading">${config.sizeHeading||'Shop by size'}</span><div class="roy-sale-sizes">${sizeLinks}</div></section>
      <section class="roy-sale-col"><span class="roy-sale-heading">${config.priceHeading||'Shop by price'}</span><div class="roy-sale-budget">
        <a class="roy-sale-link" href="${salePrice(50)}">${priceLabels[0]||'Sale under $50'}</a>
        <a class="roy-sale-link" href="${salePrice(100)}">${priceLabels[1]||'Sale under $100'}</a>
        <a class="roy-sale-link" href="${salePrice(150)}">${priceLabels[2]||'Sale under $150'}</a>
        <a class="roy-sale-link" href="${salePrice(200)}">${priceLabels[3]||'Sale under $200'}</a>
      </div></section>
    </div>`;
  }

  function enhanceSaleMenus(){
    document.querySelectorAll('.sss-mega-menu[data-menu-handle="sale"],.sss-mega-menu[data-menu-handle="last-call"]').forEach(menu => {
      if (menu.dataset.royEnhanced) return;
      const config=getSaleConfig(menu);
      menu.innerHTML = saleDesktopMarkup(config);
      if(Object.keys(config).length){
        const configNode=document.createElement('script');
        configNode.type='application/json';
        configNode.className='roy-last-call-config';
        configNode.textContent=JSON.stringify(config);
        menu.prepend(configNode);
      }
      menu.dataset.royEnhanced = 'true';
    });
    document.querySelectorAll('.burger-menu__list-first').forEach(li => {
      const first = li.querySelector(':scope > a, :scope > menu-drawer > details > summary');
      if (!first || !/^(sale|last call)$/i.test(first.textContent.trim())) return;
      const inner = li.querySelector('.burger-menu__submenu-inner');
      if (!inner || inner.querySelector('.roy-mobile-sale')) return;
      const sizeLinks = [['5','5'],['6','6'],['7','7'],['8','8'],['9','9'],['10','10'],['11','11'],['12','12']]
        .map(([l,v]) => `<a href="${saleSize(v)}">${l}</a>`).join('');
      inner.insertAdjacentHTML('beforeend', `<div class="roy-mobile-sale"><p class="roy-mobile-sale__title">Shop sale by price</p><div class="roy-mobile-sale__budgets"><a href="${salePrice(50)}">Under $50</a><a href="${salePrice(100)}">Under $100</a><a href="${salePrice(150)}">Under $150</a><a href="${salePrice(200)}">Under $200</a></div><p class="roy-mobile-sale__title">Shop by available size</p><div class="roy-mobile-sale__sizes">${sizeLinks}</div><p class="roy-mobile-sale__note">Only styles with inventory in the selected size are shown.</p></div>`);
    });
  }

  function patchQuickAdd(){
    if (!window.customElements || !customElements.get('quick-add-modal')) return false;
    const Klass = customElements.get('quick-add-modal');
    if (Klass.prototype.__royPatched) return true;
    Klass.prototype.__royPatched = true;

    Klass.prototype.preventDuplicatedIDs = function(){
      if (!this.productElement) return;
      const sectionId = this.productElement.dataset.section || this.productElement.id || '';
      if (!sectionId) return;
      this.productElement.innerHTML = this.productElement.innerHTML.split(sectionId).join(`quickadd-${sectionId}`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach(el => { el.dataset.originalSection = sectionId; });
    };

    Klass.prototype.setInnerHTML = function(element, html, opener){
      element.innerHTML = html;
      element.querySelectorAll('script').forEach(oldScript => {
        const fresh = document.createElement('script');
        [...oldScript.attributes].forEach(a => fresh.setAttribute(a.name,a.value));
        fresh.textContent = oldScript.textContent;
        oldScript.replaceWith(fresh);
      });
      const target = element.querySelector('.product .product__info-main_content, .product .product__info-main, .product .product__info-container');
      if (target && !target.querySelector('.roy-quickview-more')) {
        const more = document.createElement('a');
        more.className = 'product__full-details button button--tertiary roy-quickview-more';
        more.href = opener.getAttribute('data-product-url');
        more.innerHTML = `<span>${window.theme?.quickviewMore || 'View full details'}</span>`;
        target.appendChild(more);
      }
    };

    Klass.prototype.show = function(opener){
      const url = opener?.getAttribute('data-product-url');
      if (!url) return;
      opener.setAttribute('aria-disabled','true'); opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      fetch(url).then(r => { if(!r.ok) throw new Error('Product unavailable'); return r.text(); }).then(text => {
        const doc = new DOMParser().parseFromString(text,'text/html');
        let product = doc.querySelector('section[id^="MainProduct-"]');
        if (!product) product = doc.querySelector('section[id*="main-product"], section[id*="product"].product-section, .product-section');
        if (!product) product = doc.querySelector('.product')?.closest('section') || doc.querySelector('.product');
        if (!product) throw new Error('Quick view product markup was not found.');
        this.productElement = product;
        try { this.preventDuplicatedIDs(); } catch(e) { console.warn('Quick view ID normalization skipped',e); }
        try { this.removeDOMElements(); } catch(e) { console.warn('Quick view cleanup partially skipped',e); }
        this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);
        try { if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init(); } catch(e){}
        try { if (window.ProductModel) window.ProductModel.loadShopifyXR(); } catch(e){}
        try { this.removeGalleryListSemantic(); } catch(e){}
        try { this.updateImageSizes(); } catch(e){}
        try { this.preventVariantURLSwitching(); } catch(e){}
        ModalDialog.prototype.show.call(this, opener);
        try { this.setFocusElement(opener); } catch(e){}
      }).catch(err => {
        console.error('Quick view failed',err);
        window.location.assign(url);
      }).finally(() => {
        opener.removeAttribute('aria-disabled'); opener.classList.remove('loading');
        opener.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        try { if (typeof window.quickAddsliderInit === 'function') window.quickAddsliderInit(true,this); } catch(e){}
        try { if (typeof window.initProductDropdownSelect === 'function') window.initProductDropdownSelect(this); } catch(e){}
      });
    };
    return true;
  }

  async function fetchCartJSON(){
    const r = await fetch(`${ROOT}cart.js`, {headers:{Accept:'application/json'}, cache:'no-store'});
    return r.ok ? r.json() : null;
  }

  const umbrellaHandle = 'spring-step-lartiste-womens-umbrella-raindrop';
  function isFallWindow(){ const m = new Date().getMonth()+1; return m >= 8 && m <= 11; }

  async function seasonalCard(cart){
    if (!isFallWindow() || !cart || cart.items.some(i => i.handle === umbrellaHandle)) return '';
    try {
      const r = await fetch(`${ROOT}products/${umbrellaHandle}.js`, {headers:{Accept:'application/json'}, cache:'no-store'});
      if(!r.ok) return '';
      const p = await r.json();
      const v = (p.variants||[]).find(x => x.available) || p.variants?.[0];
      if(!v || !v.available) return '';
      const image = p.featured_image || p.images?.[0] || '';
      return `<aside class="roy-seasonal-upsell" data-roy-seasonal><p class="roy-seasonal-upsell__eyebrow">Fall-ready add-on</p><h3>One more thing for the season</h3><div class="roy-seasonal-upsell__card"><a href="${p.url || `/products/${umbrellaHandle}`}">${image ? `<img class="roy-seasonal-upsell__image" src="${image}" alt="${p.title || 'Umbrella'}" loading="lazy">` : ''}</a><div><a class="roy-seasonal-upsell__title" href="${p.url || `/products/${umbrellaHandle}`}">${p.title || 'L’Artiste Raindrop Umbrella'}</a><p class="roy-seasonal-upsell__meta">${window.Shopify?.formatMoney ? Shopify.formatMoney(v.price) : '$29.95'} · seasonal pick</p><button class="roy-seasonal-upsell__add" type="button" data-roy-add="${v.id}">Add to bag</button><p class="roy-upsell-status" role="alert" hidden></p></div></div></aside>`;
    } catch(e){ return ''; }
  }

  let drawerUpsellSyncSerial = 0;
  let drawerRefreshInProgress = false;

  async function syncDrawerUpsells(){
    const run = ++drawerUpsellSyncSerial;
    const drawer = document.querySelector('cart-drawer');
    if(!drawer || drawer.classList.contains('is-empty') || drawerRefreshInProgress) return;

    const cart = await fetchCartJSON();
    if (run !== drawerUpsellSyncSerial || !cart || !cart.item_count) return;

    const fingerprint = cart.items.map(i => `${i.variant_id}:${i.quantity}`).join('|');
    const current = drawer.querySelector('.roy-cart-upsells');
    if (current?.dataset.fingerprint === fingerprint && drawer.querySelectorAll('.roy-cart-upsells').length === 1) return;

    let completeLook = '';
    try {
      const html = await fetch(`${ROOT}cart?_roy=${Date.now()}`, {headers:{Accept:'text/html'}, cache:'no-store'}).then(r => r.text());
      if (run !== drawerUpsellSyncSerial) return;
      const doc = new DOMParser().parseFromString(html,'text/html');
      const upsell = doc.querySelector('.sss-upsell');
      if (upsell) completeLook = upsell.outerHTML;
    } catch(e){}

    const seasonal = await seasonalCard(cart);
    if (run !== drawerUpsellSyncSerial) return;

    drawer.querySelectorAll('.roy-cart-upsells').forEach(node => node.remove());
    if (!completeLook && !seasonal) return;

    const wrap = document.createElement('div');
    wrap.className = 'roy-cart-upsells';
    wrap.dataset.fingerprint = fingerprint;
    wrap.innerHTML = completeLook + seasonal;

    const cartBody = drawer.querySelector('#CartDrawer-CartItems');
    const nativeItems = cartBody?.querySelector('.drawer__cart-items-wrapper');
    if (nativeItems) nativeItems.insertAdjacentElement('afterend', wrap);
    else if (cartBody) cartBody.appendChild(wrap);
    else drawer.querySelector('.drawer__inner')?.appendChild(wrap);
  }

  async function syncFullCartSeasonal(){
    const root = document.querySelector('[data-sss-cart]');
    if(!root) return;

    // The Shopping Bag is a second-stage merchandising surface. Keep it to
    // one net-new recommendation: the server-rendered Complete the Look offer
    // wins when it exists; otherwise the seasonal offer may fill the slot.
    const completeLook = root.querySelector('.sss-upsell');
    if (completeLook) {
      root.querySelectorAll('[data-roy-seasonal]').forEach(node => node.remove());
      return;
    }

    if (root.querySelector('[data-roy-seasonal]')) return;
    const cart = await fetchCartJSON();
    const card = await seasonalCard(cart);
    if(!card) return;
    root.querySelector('#main-cart-items')?.insertAdjacentHTML('afterend',card);
  }

  async function refreshCartDrawer(addedId){
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    drawerRefreshInProgress = true;
    ++drawerUpsellSyncSerial;
    drawer.querySelectorAll('.roy-cart-upsells').forEach(node => node.remove());

    try {
      const sectionUrl = `${ROOT}cart?sections=cart-drawer,cart-icon-bubble&_roy=${Date.now()}`;
      const response = await fetch(sectionUrl, {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw new Error('Cart sections unavailable');
      const sections = await response.json();
      if (!sections || !sections['cart-drawer']) throw new Error('Cart drawer section missing');

      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents({id: addedId, sections});
      } else {
        const parser = new DOMParser();
        const currentDrawer = document.querySelector('#CartDrawer');
        const freshDrawer = parser.parseFromString(sections['cart-drawer'],'text/html').querySelector('#CartDrawer');
        if (!currentDrawer || !freshDrawer) throw new Error('Cart drawer markup unavailable');
        currentDrawer.innerHTML = freshDrawer.innerHTML;

        if (sections['cart-icon-bubble']) {
          const currentIcon = document.getElementById('cart-icon-bubble');
          const freshIcon = parser.parseFromString(sections['cart-icon-bubble'],'text/html').querySelector('#cart-icon-bubble');
          if (currentIcon && freshIcon) currentIcon.innerHTML = freshIcon.innerHTML;
        }
      }

      if (typeof drawer.resetNotificationView === 'function') drawer.resetNotificationView();
      else {
        drawer.querySelector('.notification')?.classList.remove('notification-open');
        drawer.querySelectorAll('.cart-item.active').forEach(item => item.classList.remove('active'));
      }

      drawerRefreshInProgress = false;
      setTimeout(syncDrawerUpsells, 180);
      return true;
    } catch(err) {
      drawerRefreshInProgress = false;
      console.warn('Native cart drawer refresh failed; keeping the shopper on the current page.', err);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      setTimeout(syncDrawerUpsells, 180);
      return false;
    }
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-roy-add], .cart-drawer [data-sss-add]');
    if(!btn || btn.disabled) return;
    e.preventDefault();

    const id = Number(btn.dataset.royAdd || btn.dataset.sssAdd);
    if(!id) return;

    const status = btn.parentElement?.querySelector('.roy-upsell-status,.sss-upsell-error');
    btn.disabled = true;
    const old = btn.textContent;
    btn.textContent = 'Adding…';
    if(status) status.hidden = true;

    try {
      const r = await fetch(`${ROOT}cart/add.js`, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          items:[{id,quantity:1}],
          sections:'cart-drawer,cart-icon-bubble',
          sections_url:window.location.pathname
        })
      });
      const data = await r.json();
      if(!r.ok) throw new Error(data.description || 'Could not add this item.');

      if (document.querySelector('[data-sss-cart]')) {
        window.location.reload();
      } else {
        btn.textContent = 'Added';
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections && data.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
          drawerRefreshInProgress = true;
          ++drawerUpsellSyncSerial;
          drawer.querySelectorAll('.roy-cart-upsells').forEach(node => node.remove());
          drawer.renderContents({id, sections:data.sections});
          if (typeof drawer.resetNotificationView === 'function') drawer.resetNotificationView();
          drawerRefreshInProgress = false;
          setTimeout(syncDrawerUpsells, 180);
        } else {
          await refreshCartDrawer(id);
        }
      }
    } catch(err){
      if(status){ status.textContent = err.message; status.hidden = false; }
      btn.disabled = false;
      btn.textContent = old;
    }
  });

  function boot(){
    addPrimaryNavLinks();
    enhanceSaleMenus();
    syncFullCartSeasonal();
    syncDrawerUpsells();
    if(!patchQuickAdd() && window.customElements) customElements.whenDefined('quick-add-modal').then(patchQuickAdd).catch(()=>{});

    const drawer = document.querySelector('cart-drawer');
    if(drawer){
      let timer;
      new MutationObserver((mutations) => {
        if (drawerRefreshInProgress) return;
        const onlyUpsellMutations = mutations.every(m => {
          const nodes = [...m.addedNodes, ...m.removedNodes].filter(n => n.nodeType === 1);
          return nodes.length && nodes.every(n => n.matches?.('.roy-cart-upsells') || n.closest?.('.roy-cart-upsells'));
        });
        if (onlyUpsellMutations) return;
        clearTimeout(timer);
        timer = setTimeout(syncDrawerUpsells, 450);
      }).observe(drawer,{subtree:true,childList:true});
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',()=>setTimeout(()=>{addPrimaryNavLinks();enhanceSaleMenus();patchQuickAdd();},50));
})();

